module.exports = __webpack_public_path__ + "media/luxury-2026/modern-detail-960-4c344832.jpg";